import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetCommerce, useEditCommerce } from '@pages/Commerce/hooks/commerce';

// Tablet+ (≥640px) gets full text + subtitle. Below 640px is phone-only compact.
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

export const BusinessClosedBanner = () => {
  const { commerce } = useGetCommerce();
  const { handleUpdate } = useEditCommerce();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (commerce.servicio_activo !== false) return null;

  const isOnSchedulePage = pathname.includes('horarios');

  const handleReopen = () => {
    handleUpdate({ ...commerce, servicio_activo: true }).catch(() => undefined);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        flexShrink: 0,
        background: 'linear-gradient(90deg, #A02222, #D54C4C)',
        color: '#ffffff',
        padding: isMobile ? '8px 12px' : '9px 18px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        borderBottom: '1px solid rgba(0,0,0,.12)',
        boxShadow: '0 2px 8px rgba(160,34,34,.25)',
        zIndex: 20,
      }}
    >
      {/* Pulsing dot */}
      <span style={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ffffff' }} />
        <span
          style={{
            position: 'absolute',
            inset: -4,
            borderRadius: '50%',
            border: '1.5px solid rgba(255,255,255,.6)',
            animation: 'plick-pulse 1.4s ease-out infinite',
          }}
        />
      </span>

      <div style={{ flex: 1, minWidth: 0, lineHeight: 1.3 }}>
        <div style={{ fontSize: isMobile ? 12 : 13, fontWeight: 700 }}>
          {isMobile ? 'Negocio cerrado temporalmente' : 'Tu negocio está cerrado temporalmente'}
        </div>
        {!isMobile && (
          <div style={{ fontSize: 12, opacity: 0.85, marginTop: 1 }}>
            Los clientes ven tu menú como cerrado y no pueden hacer pedidos — sin importar tus horarios.
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        {!isOnSchedulePage && (
          <button
            onClick={() => navigate('/horarios')}
            style={{
              background: 'rgba(255,255,255,.15)',
              color: '#ffffff',
              border: '1px solid rgba(255,255,255,.35)',
              borderRadius: 8,
              padding: isMobile ? '5px 10px' : '6px 12px',
              fontSize: 12,
              fontWeight: 700,
              cursor: 'pointer',
              fontFamily: 'inherit',
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              whiteSpace: 'nowrap',
            }}
          >
            {isMobile ? 'Ver' : 'Ver detalles'}
          </button>
        )}
        <button
          onClick={handleReopen}
          style={{
            background: '#ffffff',
            color: '#A02222',
            border: 0,
            borderRadius: 8,
            padding: isMobile ? '5px 12px' : '6px 14px',
            fontSize: 12,
            fontWeight: 800,
            cursor: 'pointer',
            fontFamily: 'inherit',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
            <rect x="4" y="8" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="2.5" />
            <path d="M8 8V5a4 4 0 0 1 7-2.6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
          Reabrir
        </button>
      </div>

      <style>{'@keyframes plick-pulse{0%{transform:scale(.6);opacity:1}100%{transform:scale(1.8);opacity:0}}'}</style>
    </div>
  );
};
